import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "slider" }

import { useStore } from '../store';
import { MutationType } from '../store/mutations'
import {  computed } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'BungaPlaybar',
  setup(__props) {

function pad(v:number,size?:number):string {
    var s = String(v);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
}
function formatTime(dt:number) {
            let d=new Date(dt);
            return pad(d.getHours()) + ':' + pad(d.getMinutes()) ;
        }

const store = useStore();

//increment: () => store.commit('increment'),
const firstTime=  computed(()=>  {return store.state.quakeParams!.firstTime;});
const lastTime=  computed(()=>  {return store.state.quakeParams!.lastTime; });
const displayTime = computed(()=> {
    return new Date(store.state.animParams.animTime).toLocaleString('en-GB');
});
const animTime = computed({
    get: ()=> store.state.animParams.animTime ,
    set: (value:number)=> { 
        store.commit(MutationType.SetAnimTime,value);
    },
},)


return (_ctx: any,_cache: any) => {
  const _component_o_slider = _resolveComponent("o-slider")!
  const _component_o_field = _resolveComponent("o-field")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_o_field, {
      id: "timer",
      label: displayTime.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_slider, {
          modelValue: animTime.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((animTime).value = $event)),
          "custom-formatter": val => formatTime(val),
          min: firstTime.value,
          max: lastTime.value,
          tooltipAlways: true,
          position: "bottom"
        }, null, 8, ["modelValue", "custom-formatter", "min", "max"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}
}

})